import React, { useState, useEffect} from 'react';
import { Tooltip, Image as AntdImage, Spin } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import {useHistory} from "react-router-dom";


import "./index.scss";
import Api from '../../../../../api'
import RightArrow from "../../../../../assets/img/V7/rightArrow.png";
import RightArrowBlack from "../../../../../assets/img/V7/rightArrowBlack.png";
import { setAIModalState } from "../../../../../features/AIIntelligentV7/AIReducer";
import Iconfont from "../../../../../components/Iconfont/Iconfont";
const KnowledgeTopic = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [defalutDataList, setDefalutDataList] = useState([]);

    const [dataListFirst, setDataListFirst] = useState([]);
    const [dataListSecond, setDataListSecond] = useState([]);

    const [spinning, setSpinning] = useState(false); 
    const [currentPageIndex, setCurrentPageIndex] = useState(1); 
    const [totalPage, setTotalPage] = useState(1); 
    const [marginLeftPx, setMarginLeftPx] = useState(0);
    
    useEffect(()=>{
        getInitDate();
    },[])
    const getInitDate = async() => {
        try{
            setSpinning(true);
            const res = await Api.Knowledge.getAllKnowledger({});

            setSpinning(false);
            if(res && res.code === 0 && res.data && res.data.length > 0){
                let _dataListFirst = [];
                let _dataListSecond = [];
                res.data.map((item,index)=>{
                    if ((index+1) % 2 === 0) {
                        // 偶数
                        _dataListSecond.push(item);
                    } else {
                        // 奇数
                        _dataListFirst.push(item);
                    }
                })

                setDataListFirst(_dataListFirst);
                setDataListSecond(_dataListSecond);
                if(res.data.length > 8 ){
                    setTotalPage(2);
                }
            }
        }catch(e){
            setSpinning(false);
            console.log(e);
        }
    }

    const goKnowledgeList = (item) => {
        window.open(`/page/knowledgeCentre?knowledgeTypeId=${item.id}`);
    }

    const goPage = (path) => {
        window.open(path)
    }

    const turnThePage = (pageIndex, type) => {
        if(type === "right"){
            var div = document.getElementById('slideBox');
            // 获取div的布局宽度（包括内边距和边框，但不包括外边距）
            var slideWidth = div.offsetWidth;
            var fixedDivWidth = document.querySelector('.ant-spin-container').offsetWidth;
            setMarginLeftPx(slideWidth - fixedDivWidth);
            console.log(slideWidth, fixedDivWidth);
            setCurrentPageIndex(pageIndex)
            
        }else{
            setMarginLeftPx(0);
        }
        setCurrentPageIndex(pageIndex);
    }
    
    return (
        <div className="knowledgeTopic">
            <div className="knowledgeTopicTitle">
                <div>知识专题</div>
                <div className="knowledgeTopicMore" onClick={() => goPage("/page/knowledgeCentre")}>全部专题 <img className="rightArrowBlack" src={RightArrowBlack} alt=""/></div>
            </div>

            {currentPageIndex > 1 && (
                <div className="iconLeft" onClick={()=>turnThePage(currentPageIndex-1,"left")}>
                    <Iconfont type={'icon-you'}/>
                </div>
            )}

            <Spin spinning={spinning}>
                <div className="slideBox" id="slideBox" style={{marginLeft:`-${marginLeftPx}px`}}>
                    <div className="knowledgeTopicBox">
                        {dataListFirst.map(item=>{
                            return (
                                <div
                                    key={item.id}
                                    className="knowledgeTypeCard"
                                    onClick={()=>{
                                        goKnowledgeList(item)
                                    }}
                                >
                                    <div className="knowledgeTypeCardImage">
                                        {item.url?<AntdImage
                                            width={30}
                                            preview={false}
                                            src={item.url}
                                        />:''}
                                    </div>
                                    <div>
                                        <div className="knowledgeTypeCardTitle">
                                            {item.knowledgeTypeName}
                                            <img className="rightArrow" src={RightArrow} alt=""/>
                                        </div>
                                        <Tooltip title={item.intro} placement="topLeft">
                                            <div className="knowledgeTypeCardDescription" title={item.intro}>{item.intro}</div>
                                        </Tooltip>
                                    </div>
                                </div>
                            )
                        })}
                        <i></i><i></i><i></i>
                    </div>
                    <div className="knowledgeTopicBox">
                        {dataListSecond.map(item=>{
                            return (
                                <div
                                    key={item.id}
                                    className="knowledgeTypeCard"
                                    onClick={()=>{
                                        goKnowledgeList(item)
                                    }}
                                >
                                    <div className="knowledgeTypeCardImage">
                                        {item.url?<AntdImage
                                            width={30}
                                            preview={false}
                                            src={item.url}
                                        />:''}
                                    </div>
                                    <div>
                                        <div className="knowledgeTypeCardTitle">
                                            {item.knowledgeTypeName}
                                            <img className="rightArrow" src={RightArrow} alt=""/>
                                        </div>
                                        <Tooltip title={item.intro} placement="topLeft">
                                            <div className="knowledgeTypeCardDescription" title={item.intro}>{item.intro}</div>
                                        </Tooltip>
                                    </div>
                                </div>
                            )
                        })}
                        <i></i><i></i><i></i>
                    </div>
                </div>
            </Spin> 

            {currentPageIndex < totalPage && (
                <div className="iconRight" onClick={()=>turnThePage(currentPageIndex+1,"right")}>
                    <Iconfont type={'icon-you'}/>
                </div>
            )}
        </div>
    );
}
export default KnowledgeTopic;
